import { useDispatch } from 'react-redux';
import { fetchSingleNewsAssets } from '@client/content/redux/newsroom/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useFetchSingleNewsAssetsAction = (): typeof fetchSingleNewsAssets => {
  const dispatch = useDispatch();

  return bindActionCreators(fetchSingleNewsAssets, dispatch);
};
